import { render, staticRenderFns } from "./ProfileListItem.vue?vue&type=template&id=35b8a744"
import script from "./ProfileListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileListItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileListItem.vue?vue&type=style&index=0&id=35b8a744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports